import { render, staticRenderFns } from "./role-permission.vue?vue&type=template&id=8c966d36&"
import script from "./role-permission.ts?vue&type=script&lang=ts&"
export * from "./role-permission.ts?vue&type=script&lang=ts&"
import style0 from "./role-permission.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports